'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _revalidate = require('revalidate');

var validate = exports.validate = (0, _revalidate.combineValidators)({
  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting \"I\'m not a robot\" above'
  }),

  acceptTos: (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      return value === true ? undefined : message;
    };
  }, 'Please read and accept the Terms of Service before confirming your purchase.')()
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/upgradeToAnnualFormValidation.js
// module id = 2548
// module chunks = 0